import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getEnumValue'
})
export class GetEnumValuePipe implements PipeTransform {
  /**
   * Trả về giá trị value của enum
   * @param value Giá trị truyền vào
   * @param args Source data để tìm kiếm
   * @returns 
   */
  transform(value: number, ...args: any[]): any {
    let searchRes = '';
    let sourceData: any[] = [];
    let valueField: any = 'id';
    let displayField: any = 'name';
     if (args && args.length > 0) {
      sourceData = args[0];
    }
    if (args && args.length > 1) {
      valueField = args[1];
    }
     if (args && args.length > 2) {
      displayField = args[2];
    }
    if (value !== undefined && value !== null && !isNaN(value) && sourceData !== undefined && sourceData !== null) {
      searchRes = sourceData.find(function(item){
          return item[valueField] == value;
      });
      return (searchRes !== undefined && searchRes !== null ? searchRes[displayField] : '');
    }
    return null;
  }

}
